<template>
  <div class="user_usage">
    <Loading v-if="!user" />
    <div v-if="user">
      <v-layout column align-center>
        <v-container fluid>
          <v-row class="align-center">
            <v-col>
              <v-row class="align-center">
                <v-col class="text-right">
                  <span class="text-h6"> {{ user.name }} </span>
                </v-col>

                <v-col class="text-left">
                  <user-actions
                    :user="user"
                    show_view
                    show_orders
                  ></user-actions>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row class="align-center">
                <v-col class="text-right">
                  {{ account.name }}
                </v-col>
                <v-col class="text-left">
                  <account-actions
                    :account="account"
                    show_details
                    show_usage
                    show_orders
                    show_users
                  ></account-actions>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <hr />
          <br />
          <usage-table
            :usage="user_usage"
            :tasking_usage="tasking_usage"
            :usage_date="response_date"
            :start_date="start_date"
            :end_date="end_date"
            :loading="loading"
            @usage_range_changed="refresh_usage($event.start, $event.end)"
            @view_orders="view_orders($event.start_date, $event.end_date)"
          >
          </usage-table>
        </v-container>
      </v-layout>
    </div>
  </div>
</template>
<script>
import adminApi from "@/api/admin";
import usageApi from "@/api/usage";
import store from "@/store/index";
import UsageTable from "@/components/usage/UsageTable.vue";
import UserActions from "@/components/user/UserActions.vue";
import AccountActions from "@/components/account/AccountActions.vue";
import { mapGetters } from "vuex";
import utils from "@/utils/userType";
import Loading from "@/components/shared/Loading.vue";

export default {
  name: "AccountUsage",
  components: {
    UsageTable,
    UserActions,
    AccountActions,
    Loading,
  },
  data: function () {
    return {
      user_info: store.state.user,
      loading: false,
      user_usage: null,
      tasking_usage: null,
      user: null,
      account: null,
      response_date: null,
      start_date: this.$route.query.start_date || null,
      end_date: this.$route.query.end_date || null,
    };
  },
  mounted() {
    this.gather_page_info();
  },
  computed: {
    ...mapGetters(["user_details", "account_details"]),
    is_admin_or_support() {
      return utils.is_admin_or_support(this.user_details);
    },
  },
  watch: {
    $route() {
      this.gather_page_info();
      this.refresh_usage();
    },
  },
  methods: {
    get_user_info() {
      return adminApi
        .get_user(this.$route.params.account_id, this.$route.params.user_id)
        .then((response) => {
          this.user = response.data.user;
          this.refresh_usage();
        })
        .catch(() => {
          this.user_usage = {};
        });
    },
    hasValidDates() {
      if (this.$route.query.start_date && this.$route.query.end_date) {
        const startDate = new Date(this.$route.query.start_date).getTime();
        const endDate = new Date(this.$route.query.end_date).getTime();

        return startDate <= endDate || endDate >= startDate;
      }

      return false;
    },
    async refresh_usage() {
      if (this.hasValidDates()) {
        this.loading = true;
        const start_date = this.$route.query.start_date || null;
        const end_date = this.$route.query.end_date || null;
        let query_string = "";
        if (start_date) {
          query_string += `start_date=${start_date}`;
        }
        if (end_date) {
          if (query_string) {
            query_string += "&";
          }
          query_string += `end_date=${end_date}`;
        }

        try {
          const response = await usageApi.get_user_usage(
            this.$route.params.user_id,
            query_string
          );
          this.response_date = response.data.response_timestamp;
          this.user_usage = response.data.usage;
          this.tasking_usage = response.data.tasking_usage;
        } catch (err) {
          this.user_usage = {};
        } finally {
          this.loading = false;
        }
      }
    },

    view_orders(start_date, end_date) {
      if (this.is_admin_or_support) {
        const account_id = this.$route.params.account_id;
        this.$router.push({
          name: "account-orders",
          params: { account_id: account_id },
          query: {
            start_date: start_date,
            end_date: end_date,
            filters: [`user_id:${this.$route.params.user_id}`],
          },
        });
      } else {
        this.$router.push({
          name: "my-orders",
          params: { account_id: this.user_details.account_id },
          query: {
            start_date: start_date,
            end_date: end_date,
            filters: [`user_id:${this.user_details.user_id}`],
          },
        });
      }
    },

    gather_page_info() {
      return adminApi
        .get_account(this.$route.params.account_id)
        .then((response) => {
          this.account = response.data.account;
          this.get_user_info();
        })
        .catch(() => {
          // catch redundant path error
        });
    },
  },
};
</script>
<style></style>
